<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">公司名称</p>
        <el-input v-model="renterCompanyName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">公司地址</p>
        <el-input v-model="companyAddr" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addFormData">新增企业</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{ prop: 'id', order: 'descending' }"
          style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{ background: '#F4F7FA', color: '#606266' }">
          <template v-for="(item, index) in tableColumns">
            <el-table-column v-if="item.prop === 'enableStatus'" :key="index" :prop="item.prop" :label="item.label"
              :width="item.width">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.enableStatus === 1 ? '启用' : '禁用' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.prop === 'renterCompanyName'" :key="index" :prop="item.prop" :label="item.label"
              :width="item.width">
              <template slot-scope="scope">
                  <el-link  type="primary"  @click="viewOrHandle(scope.row, 'view')" size="small">{{scope.row.renterCompanyName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row, 'edit')" type="text" size="small">编辑</el-button>
              <!-- <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">查看详情</el-button> -->
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" :disabled="viewShow">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名" prop="renterCompanyName" class="formItem">
                <el-input v-model="addForm.renterCompanyName" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司地址" prop="companyAddr" class="formItem">
                <el-input v-model="addForm.companyAddr" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="法人" prop="legalPerson" class="formItem">
                <el-input v-model="addForm.legalPerson" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactPerson" class="formItem">
                <el-input v-model="addForm.contactPerson" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人电话" prop="contactPhone" class="formItem">
                <el-input v-model="addForm.contactPhone" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="安全员" prop="mobile" class="formItem">
                <el-input v-model="addForm.safePerson" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="安全员电话" prop="safePhone" class="formItem">
                <el-input v-model="addForm.safePhone" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产业类型" prop="businessType" class="formItem">
                <el-input v-model="addForm.businessType" clearable placeholder="请输入" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="!viewShow">
              <el-form-item label="企业官网链接" prop="officialWebsiteLink" class="formItem">
                <el-input v-model="addForm.officialWebsiteLink" clearable placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="viewShow">
              <el-form-item label="企业官网链接" prop="officialWebsiteLink" class="formItem">
                <el-link type="primary" :href="addForm.officialWebsiteLink" :underline="false" target="_blank">{{addForm.officialWebsiteLink}}</el-link>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="营业执照" class="formItem">
            <uploadImg @handleFileImg="handleFileImg" :attachmentUrlList='addForm.attachmentUrl' :uploadShow="viewShow"></uploadImg>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeData">取 消</el-button>
          <el-button type="primary" @click="addEventForm()" v-if="!viewShow">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { baseRenterCompany } from '@/api/basicInfo'
import uploadImg from '@/components/upload/uploadImg'
import { emptyValidPhone } from '@/assets/scripts/validate'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
export default {
  name: 'accountPage',
  components: {
    uploadImg
  },
  data() {
    return {
      loading: false,
      viewShow: false,
      roleName: '',
      renterCompanyName: '',
      companyAddr: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '新增企业',
      edit: false,
      passwordForm: {},
      addForm: {
        renterCompanyName: '', // 公司名称
        companyAddr: '', // 公司地址
        legalPerson: '', // 法人
        contactPerson: '', // 联系人
        contactPhone: '', // 联系人
        safePerson: '', // 安全员
        safePhone: '', // 安全员
        businessType: '', // 产业类型
        attachmentUrl: '', // 附件地址
        officialWebsiteLink: '', // 官网地址
        renterId: '',
      },
      rules: {
        renterCompanyName: [{ required: true, message: '请填写', trigger: 'blur' }],
        legalPerson: [{ required: true, message: '请填写', trigger: 'blur' }],
        companyAddr: [{ required: true, message: '请填写', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请填写', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请填写', trigger: 'blur' }],
        businessType: [{ required: true, message: '请填写', trigger: 'blur' }],
        safePhone: [{ validator: emptyValidPhone, trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'renterCompanyName',
          label: '公司名称'
        },
        {
          prop: 'companyAddr',
          label: '公司地址'
        },
        {
          prop: 'businessType',
          label: '产业类型'
        },
        {
          prop: 'contactPerson',
          label: '联系人'
        },
        {
          prop: 'contactPhone',
          label: '联系电话'
        }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleFileImg(imgs) {
      let arrUrl = imgs.map(v => v.code)
      this.addForm.attachmentUrl = arrUrl.join(',')
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await baseRenterCompany('query', {
        renterCompanyName: this.renterCompanyName,
        companyAddr: this.companyAddr,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增企业'
    },
    async viewOrHandle(row, type) {
      this.edit = true
      this.newOldFormContrast(row)
      this.dialogFormVisible = true
      if (type === 'view') {
        this.viewShow = true
        this.eventControl = '查看企业'
      } else {
        this.viewShow = false
        this.eventControl = '编辑企业'
      }
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.addForm.id = newForm.id
    },
    closeData() {
      this.dialogFormVisible = false
      this.viewShow = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          // this.addForm.attachmentUrl = this.addForm.attachmentUrl.length > 0 ? this.addForm.attachmentUrl.join(',') : ''
          if (this.edit) {
            let res = await baseRenterCompany('update', this.addForm)
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await baseRenterCompany('add', this.addForm)
            if (res.code === 0) {
              Message.success('新增成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除用户
    deleteFun(row) {
      this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await baseRenterCompany('deleteById', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        } else {
          Message.error(res.message)
        }
        await this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}

.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {}

  .paginationBody {
    margin-top: .1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog {
  width: 50% !important;
}
</style>
